import React from "react";
import Navbar from "../../component/HomeHeader";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const therapistData = JSON.parse(localStorage.getItem("therapistSignedIn"));
const therapist = therapistData?.user;
console.log(therapistData);
export default function TherapistDashboard() {
  return (
    <div>
      <Navbar />
      <div className="bg-[#DCAE96] m-12 py-5 rounded-3xl">
        <div className="bg-white p-2 mx-4 rounded-2xl shadow-md">
          <div className="flex flex-col gap-4 px-4 py-4">
            <div className="flex">
              <img
                src="https://res.cloudinary.com/deofacwik/image/upload/v1694602402/man_nhczm5.jpg"
                alt="man"
                className="w-36 h-36 rounded-full object-cover"
              />
              <div className="text-[#295700] mt-8 pl-8">
                <p className="uppercase text-xl font-semibold mb-4">
                  {therapist.lastName} {therapist.firstName}
                </p>
                <p>State: {therapist.location}</p>
                <p>
                  <span className=""> Specialty: </span>{" "}
                  {therapist.specialization}
                </p>
              </div>
            </div>
            <div className="">
              <p class="mt-8 text-[#295700] font-semibold px-4">
                {therapist.specialization}
              </p>
              <p class="text-[#295700] items-center mb-2 mt-2 px-4">
                {/* I am a compassionate Licensed Professional Counsellor with over
                a decade of experience supporting individuals and families. My
                commitment to mental health advocacy and creating a sage,
                healing space drives my work in the field. */}
                {}
              </p>
            </div>
          </div>
          <div className="flex justify-center">
            <Link to="/therapistapplication">
              <button className="text-white font-semibold bg-[#295700] rounded-md px-12 py-2 my-4">
                EDIT PROFILE
              </button>
            </Link>
          </div>
          {/* Booked Appointment */}
          <div className="flex flex-col bg-gray-200 shadow-md rounded-md mt-4 p-4">
            <h3 className="text-xl text-[#295700] font-bold mb-2">
              Booked Appointment
            </h3>
            <p className="text-[#295700]">Rusheed Judman | 3:00 AM</p>
            <div className="flex flex-row space-between mt-4">
              <button // onClick={initiateVoiceCall}
                className="px-4 py-2 mr-4 bg-[#295700] text-white rounded-md shadow-md focus:outline-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 011.037-.443 48.282 48.282 0 005.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
                  />
                </svg>
              </button>
              <button // onClick={initiateVoiceCall}
                className="px-4 py-2 mr-4 bg-[#295700] text-white rounded-md shadow-md focus:outline-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                  />
                </svg>
              </button>
              <button // onClick={initiateVoiceCall}
                className="px-4 py-2 mr-4 bg-[#295700] text-white rounded-md shadow-md focus:outline-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
